import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './vue-i18n'
import vuex from './store'
import vuetify from './plugins/vuetify'
import VueDOMPurifyHTML from 'vue-dompurify-html';
import cspUtil from '@/csp/cspUtil'

// Cookie Consent styles
import '@/assets/css/cookieConsent.css'

// 配置 DOMPurify
const purifyConfig = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen', 'target', 'rel'],
  hooks: {
    afterSanitizeAttributes: function (node) {
      // 自動為所有 target="_blank" 的連結加上安全屬性
      if (node.tagName === 'A' && node.hasAttribute('target') && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
      }
    }
  }
}
const app = createApp(App)
app.config.globalProperties.$cspUtil = cspUtil;

if (window.location.hostname === 'localhost') {
  app.config.globalProperties.$serverUrl = 'https://official3uat.pegatroncorp.com/';
} else {
  app.config.globalProperties.$serverUrl = window.location.origin + '/';
}

if (window.location.hostname === 'localhost'
  || window.location.hostname.toLocaleLowerCase().includes('uat')
  || window.location.hostname.toLocaleLowerCase().includes('dev')) {
  app.config.globalProperties.$annualReport = 'content/investors/26'
  app.config.globalProperties.$revenu = 'content/financial-information/36'
  app.config.globalProperties.$activity = 'content/material-information-activities/39'
  app.config.globalProperties.$investorRelation_menuId = '3';
  app.config.globalProperties.$investorRelation_irId = '10';
} else {
  app.config.globalProperties.$annualReport = 'content/investors/67'
  app.config.globalProperties.$revenu = 'content/financial-information/82'
  app.config.globalProperties.$activity = 'content/material-information-activities/92'
  app.config.globalProperties.$investorRelation_menuId = '63';
  app.config.globalProperties.$investorRelation_irId = '5';
}

app.config.globalProperties.$iframeUrl = ''
app.config.globalProperties.$newsUrl = ''
app.config.globalProperties.$recaptchaKey = '6LfQYjEUAAAAAFUiqTsH_n63v0mvShcFnZ09oCcs'

app.use(router).use(i18n).use(vuex).use(vuetify).use(VueDOMPurifyHTML, { default: purifyConfig }).mount('#app')

// Expose store to window for console debugging (dev only)
if (window.location.hostname === 'localhost') {
  window.$store = vuex;
}

// Initialize Cookie Consent after app is mounted
import { nextTick } from 'vue'
nextTick(() => {
  vuex.dispatch('cookieConsent/init')
})
